import React from "react"
import { Link } from "gatsby"
import slugify from 'slugify'

import { TagsWrapper } from "./styles"

const Tags = ({ tags }) => {
  return (
    <TagsWrapper>
      <h3>Tags</h3>
      <ul className="tags_container">
        {tags.map(tag => (
          <li className="tag" key={tag}>
            <Link to={`/tags/${slugify(tag, '-')}/`}>{tag}</Link>
          </li>
        ))}
      </ul>
    </TagsWrapper>
  )
}

export default Tags
